import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Components/Main/HomePage/Authentication/Login";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const LoginTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="Login">
      <TabletNotice page="Login" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default LoginTablet;